import { render, staticRenderFns } from "./JournalistDashboardLink.vue?vue&type=template&id=e80e2440"
import script from "./JournalistDashboardLink.vue?vue&type=script&lang=js"
export * from "./JournalistDashboardLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports